import { render, staticRenderFns } from "./surat-jalan.vue?vue&type=template&id=5c0d0d88&scoped=true&"
import script from "./surat-jalan.vue?vue&type=script&lang=js&"
export * from "./surat-jalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0d0d88",
  null
  
)

export default component.exports